export default __webpack_public_path__ + "static/media/slot-confirm-icon.06686b1f.svg";